<template>
    <v-sheet v-if="isTest" dark color="warning" class="px-6 py-4 text-none">
        <p class="mb-0 text-center">
            Ini adalah aplikasi untuk testing, aplikasi yang asli bisa diakses
            melalui
            <a
                class="font-weight-bold text-decoration-none white--text"
                href="https://sipensekdik.banjarmasinkota.go.id"
                target="_blank"
            >
                sipensekdik.banjarmasinkota.go.id
            </a>
        </p>
    </v-sheet>
</template>

<script>
export default {
    data() {
        return {
            isTest: process.env.MIX_IS_TEST
        };
    }
};
</script>
